import { MutationTree } from 'vuex'
import { IBankdata, IFacturaEState, IProfessional } from '@/store/modules/facturaE/facturaETypes'

export const mutations: MutationTree<IFacturaEState> = {
  SET_INVOICE_ID(state:IFacturaEState, invoiceId: string) {
    state.invoiceId = invoiceId
  },
  SET_PAYMENT_TYPE(state:IFacturaEState, paymentType: string) {
    state.paymentType = paymentType
  },
  SET_BANKDATA(state:IFacturaEState, bankdata: IBankdata[]) {
    state.bankdata = bankdata
  },
  SET_PROFESSIONAL_LIST(state:IFacturaEState, profesionalList: IProfessional []) {
    state.professionalList = profesionalList
  },
  SET_SELECTED_PROFESSIONAL(state:IFacturaEState, profesional: IProfessional) {
    state.selectedProfessional = profesional
  },
  RESET_PROFESSIONAL(state:IFacturaEState) {
    state.professionalList = []
    state.selectedProfessional = null
  },
}
